export const data = [
  {
    id: 1,
    title: "NEO",
    date:"Keanu Reeves",
    desc:
      "In his normal life, he is a quiet programmer for the respectable software company Meta Cortex; while in private, he is a computer hacker who penetrates computer systems illicitly and steals information under his hacker alias Neo. He also sells illegal untraceable computer systems and hacking programs along with controlling computer viruses stashed on CDs and diskettes. During his time as a hacker, Anderson has learned about something known only as The Matrix.",
    image:
      "https://wallpapercave.com/wp/wp5635806.jpg",
  },
  {
    id: 2,
    title: "TRINITY",
    date:"Carrie-Anne Moss",
    desc:
      "Like the series' other main characters, Trinity is a computer programmer and a hacker who has escaped from the Matrix, a sophisticated computer program where most humans are imprisoned. Though few specifics are revealed about her previous life inside the Matrix, it is told that she cracked a database so secure that she is famous among hackers, and that Morpheus, one of a number of real-world hovercraft commanders, initially identified her and helped her escape from the program.",
    image:
      "https://wallpapercave.com/wp/wp10476116.jpg",
  },
  {
    id: 3,
    title: "MORPHEUS",
    date:"Laurance Fishburne",
    desc:
      "In the Matrix films, Morpheus is the captain of the Nebuchadnezzar, which is a hovercraft of the human forces of the last human city, Zion, in a devastated world where most humans are grown by sentient machines to be used as power sources and their minds kept imprisoned in the Matrix, a virtual computer-generated world, to stop them from realising the truth of the real world. Morpheus was once a human living inside the Matrix until he was freed.",
    image: "https://wallpapercave.com/wp/wp7335409.jpg",
  },
  {
    id: 4,
    title: "AGENT SMİTH",
    date:"Hugo Weaving",
    desc:
      "Smith began as an Agent, an AI program in the Matrix programmed to keep order within the system by terminating human simulacra which would bring instability to the simulated reality, as well as any rogue programs that no longer serve a purpose to the Machine collective. To this end, Smith and his fellow Agents possess a number of superhuman attributes from their ability to bend the rules of the Matrix.",
    image:
      "https://wallpapercave.com/wp/wp8435078.jpg",
  },
  {
    id: 5,
    title: "ORACLE",
    date:"Gloria Foster",
    desc:
      "In the first film, the Oracle is depicted as a cheerful old lady who smokes cigarettes and bakes cookies. She possesses the power of foresight, which she uses to advise and guide the humans attempting to fight the Matrix. Later, she is revealed to be a sapient program who is integral to the very nature of the Matrix itself.",
    image: "https://www.looper.com/img/gallery/the-history-of-the-oracle-in-the-matrix-explained/l-intro-1636486105.jpg",
  },
  {
    id: 6,
    title: "NIOBE",
    date:"Jada Pinkett Smith",
    desc:
      "Niobe is a human from Zion, being one of the rebels participating in the war against the Machines and the Matrix. She is the captain and pilot of a Zion hovercraft, the Logos, the smallest (and therefore most maneuverable) ship in the human fleet with a crew of only three: herself, weapons expert and First Mate Ghost, and Operator Sparks.",
    image:
      "https://i.pinimg.com/564x/e6/eb/2e/e6eb2e109bc3e4843370d62f70331457.jpg",
  },
  {
    id: 7,
    title: "PERSEPHONE",
    date:"Monica Belluci",
    desc:
      "In The Matrix Reloaded, Persephone meets Neo, Trinity and Morpheus when they come to talk with The Merovingian, her husband. Though her husband declines to help the human resistance, Persephone is sexually attracted to Neo and offers to help him if he kisses her with the same passion with which he has kissed Trinity. Reluctantly, he complies and she helps him free the Keymaker. Later, she kills one of her husband's employees.",
    image:
      "https://nedhardy.com/wp-content/uploads/2022/12/Monica-Bellucci-The-Matrix.jpg",
  },
  {
    id: 8,
    title: "MEROVİNGİAN",
    date:"Lambert Wilson",
    desc:
      "The Merovingian is an old program that resides within the Matrix. Self-described as a trafficker of information, The Merovingian behaves much as a leader of a powerful organized crime syndicate. He and his wife Persephone operate a smuggling ring providing a haven for exiled programs in the Matrix. The Merovingian is described as an Operating System by The Kid in his blog incorporated in The Matrix Online, although this presumably describes his role pre-Exile rather than his current function.",
    image: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhlYjo_chfWu1YtR3PmPvpv0IDclb7-AdRhoivZo_Hel4vpVpUCJcvh895fdq0iJbhu52p88zTuJdr_6LRwZ7eODfm-vjhuTvBVajGDxz06nl7kr4aih5_rcOZpYUkX62uwM3iMWsUtX06eiZkPiq--gsBkQPJpKgceBbmUgnP_VRM1Q1rFG-sq3IC7/s770/Matrix-Reloaded-Merovingian.jpg",
  },
  {
    id: 9,
    title: "THE ARCHİTECT ",
    date:"Helmut Bakaitis",
    desc:
      "The Architect is a highly specialized, emotionally desolate program of the Machine world, as well as the creator of the Matrix. As the primary superintendent of the system, he is possibly a collective materialisation, or at the very least a virtual representation of the entire Machine mainframe.",
    image:
      "https://www.cbr.com/wp-content/uploads/2020/09/The-Matrix-4-The-Architect.jpg",
  },
  {
    id: 10,
    title: "SERAPH",
    date:"Collin Chou",
    desc:
      "A program that appears as a human of Asian descent, Seraph behaves as a guardian, similar to a computer login screen equipped with a powerful Challenge-Handshake Authentication Protocol; to protect access to more important programming, it challenges anyone for the proper credentials. In this case, Seraph fights the challenger, allowing those with sufficient fighting skill (and the rightful reasons to access) to meet The Oracle.",
    image:
      "https://i.pinimg.com/originals/e8/1b/cc/e81bcc83e0621bf1b4e3febcb9a4952d.jpg",
  },
  {
    id: 11,
    title: "THE KEYMAKER",
    date:"Randall Duk Kim",
    desc:
      "The Keymaker was a program created to open up the door to the Source for The One. In the Sixth Matrix he was kept prisoner in the Chateau of the Merovingian, during which time he saved Niobe and Ghost from an Agent. Morpheus, Neo and Trinity, with the help of Persephone, manage to free the Keymaker.",
    image: "https://y.yarn.co/cbf1b8b4-ce42-4b78-b830-6841ea431eb5_screenshot.jpg",
  },
  {
    id: 12,
    title: "LINK",
    date:"Harold Perrineau",
    desc:
      "Link was a freeborn who grew up in Zion. He married Zee, the sister of Tank and Dozer. He promised Dozer that if anything happened to Tank; he would take up his job.Link had previously been the operator on board another ship for AK, who was killed by an Agent while trying to exit before the events leading to Tank and Dozer's death. When this happened, as promised, he joined the crew of the Nebuchadnezzar, becoming their new Operator.",
    image:
      "https://www.looper.com/img/gallery/why-link-from-the-matrix-reloaded-looks-so-familiar/l-intro-1612013994.jpg",
  },
];
